module.exports = __webpack_public_path__ + "static/media/g-color.9aec016e.png";